<script>
import InvoicesApi from "@/services/invoices-api";

export default {
  components: { },
      props: {
        status: Number,
        customerId:Number,
        start:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        }
      },

    mounted(){
      this.role=sessionStorage.getItem("userr");
      this.getInvoices();
    },
    data (){
        return {
            role:null,
            invoicesList:[],
            pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
            isTableLoading:false,
            tableFieldsForSupplier: [
              { key:"type", label: "",thClass:"align-middle", tdClass:"align-middle font-weight-bold" },
              { key:"number", label: "", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},
              { key:"customer", label: "", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},
              { key:"formattedDate", label: "",thClass:"align-middle", tdClass:"align-middle" },
              { key:"formattedDueDate", label: "",thClass:"align-middle", tdClass:"align-middle" },
              { key:"totalAsString", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"totalTTCAsString", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"status", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              ],
            tableFieldsForCustomer: [
              { key:"type", label: "",thClass:"align-middle", tdClass:"align-middle font-weight-bold" },
              { key:"number", label: "", thClass:"align-middle", tdClass:"font-weight-bold align-middle"},
              { key:"formattedDate", label: "",thClass:"align-middle", tdClass:"align-middle" },
              { key:"formattedDueDate", label: "",thClass:"align-middle", tdClass:"align-middle" },
              { key:"totalAsString", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"totalTTCAsString", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"status", label: "",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              ],

              exportInvoicesInProgress : false,
        }
    },
    methods: {

    getInvoices() {
      this.isTableLoading = true;
      InvoicesApi.getInvoices(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end)
        .then(result => {
          this.invoicesList = result.list
          this.pagemodel.totalRows = result.total;
          this.pagemodel.currentPage = result.page;
          this.pagemodel.perPage = result.pageSize;
          this.pagemodel.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isTableLoading = false;
      })
    },

    statusToColor(status) {
      switch(status) {
        case 0: return 'warning';
        case 1: return 'success';
        case 2: return 'info'
        case 3: return 'danger';
        default: return '';
      }
    },

    statusToLabel(status) {
      switch(status) {
        case 0: return 'unpaid';
        case 1: return 'inprogress';
        case 2: return 'paid';
        default: return '';
      }
    },

    TypeToLabel(status) {
      switch(status) {
        case 0: return 'creditBill';
        case 1: return 'bill';
        default: return '';
      }
    },

    exportInvoicesListExcel: function() {
        return InvoicesApi.export(this.pagemodel.currentPage, this.pagemodel.perPage,this.customerId,this.status,this.start,this.end)
    },

    },
    watch: {
        status : function(){
          this.getInvoices()
        },
        
        customerId: function(){
          this.getInvoices()
        },

        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getInvoices()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getInvoices()

          }
        },
    }
};
</script>
<template>
<div>

      <div class="table-responsive mt-3">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"
        :small="false"
        :hover="true"
        :items="invoicesList"
        :fields="role==0 ? tableFieldsForCustomer : tableFieldsForSupplier"
        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
          <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </template>

        <template v-slot:head(type)>
          {{ $t("invoicesMenu.list.headers.type") }} 
        </template>

        <template v-slot:head(number)>
          {{ $t("invoicesMenu.list.headers.number") }} 
        </template>

        <template v-slot:head(customer)>
          {{ $t("invoicesMenu.list.headers.customer") }} 
        </template>

        <template v-slot:head(formattedDate)>
          {{ $t("invoicesMenu.list.headers.formattedDate") }} 
        </template>

        <template v-slot:head(formattedDueDate)>
          {{ $t("invoicesMenu.list.headers.formattedDueDate") }} 
        </template>

        <template v-slot:head(totalAsString)>
          {{ $t("invoicesMenu.list.headers.totalAsString") }} 
        </template>

        <template v-slot:head(totalTTCAsString)>
          {{ $t("invoicesMenu.list.headers.totalTTCAsString") }} 
        </template>

        <template v-slot:head(status)>
          {{ $t("invoicesMenu.list.headers.status") }} 
        </template>

        <template v-slot:cell(type)="{value}">
          <i :class="value==0  ? 'fas fa-receipt font-size-18 mr-2' :  'fas fa-file-invoice-dollar text-success font-size-18 mr-2' " ></i><span :class="value==0  ? 'text-muted' : 'text-success' ">{{$t("invoicesMenu.types."+TypeToLabel(value))}}</span>
        </template>

        <template v-slot:cell(status)="{value}">
          <h5><b-badge href="#" :variant="statusToColor(value)">{{$t("invoiceState.status."+statusToLabel(value))}}</b-badge></h5>
        </template>

        <template v-slot:cell(totalAsString)="{value}">
          {{value}}
        </template>

        <template v-slot:cell(totalTTCAsString)="{value}">
          {{value}}
        </template>


        </b-table>
        <span v-if="!isTableLoading && invoicesList && !invoicesList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("invoicesMenu.list.empty")}}</span>
    </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getInvoices()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getInvoices()" :disabled="isTableLoading"></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->


</div>
</template>                                                                                                                                                                                                                                                                                                                  